import React from "react";
import SimpleScriptBox from "../../../ProjectSheet/SimpleScriptBox/SimpleScriptBox";
import AddAttachments from "../AddAttachments/AddAttachments";
import ScriptBox from "../../../../components/ScriptBox/ScriptBox";
import ModalHeader from "../ModalHeader/ModalHeader";
import CreateActivity from "../CreateActivity/CreateActivity";
import AttachmentIcon from "../../../../components/VectorIcons/AttachmentIcon";
import { getContentTypeLabel } from "../../../../shared/constants/contentType";

const NewActivityModals = (props) => {
  const {
    showAttachmentModal,
    setShowAttachmentModal,
    currentProject,
    type,
    getAttachments,
    openProjectActivityModal,
    openResearchActivityModal,
    files: stateFiles,
    toggleActiveCheckBox,
    toggleActiveVersionCheckBox,
    clearActive,
    onActivityCreated,
  } = props;

  // ModalHeader/CreateActivity are shared with flows still using PT-BR type labels and string formats.
  const projectTypeLabel = getContentTypeLabel(currentProject?.type);
  const formatName = currentProject?.format?.name;

  return (
    <>
      {!!showAttachmentModal && (
        <SimpleScriptBox
          open={!!showAttachmentModal}
          title="Selecionar anexos"
          icon={<AttachmentIcon />}
          removePadding={true}
          resizeHeader={true}
          toggleScriptBox={() => setShowAttachmentModal(false)}
        >
          <AddAttachments
            files={stateFiles}
            toggleActiveCheckBox={toggleActiveCheckBox}
            toggleActiveVersionCheckBox={toggleActiveVersionCheckBox}
            clearActive={clearActive}
            closedModal={() => setShowAttachmentModal(false)}
            contentFormat={
              showAttachmentModal === "research"
                ? formatName
                : undefined
            }
          />
        </SimpleScriptBox>
      )}

      {openProjectActivityModal && (
        <ScriptBox
          open={openProjectActivityModal}
          icon={
            <ModalHeader
              title={currentProject?.title}
              creators={currentProject?.creators}
              type={projectTypeLabel}
              format={formatName}
            />
          }
          resizeHeader={true}
          removePadding={true}
          marginBottom={true}
        >
          <CreateActivity
            files={stateFiles}
            toggleActiveCheckBox={toggleActiveCheckBox}
            toggleActiveVersionCheckBox={toggleActiveVersionCheckBox}
            listAttachments={() => setShowAttachmentModal("project")}
            clearActive={clearActive}
            type={type}
            currentProject={currentProject?.id}
            projectType={projectTypeLabel}
            format={formatName}
            onSuccess={onActivityCreated}
          />
        </ScriptBox>
      )}

      {openResearchActivityModal && (
        <ScriptBox
          open={openResearchActivityModal}
          icon={
            <ModalHeader
              title={currentProject?.title}
              creators={currentProject?.researchers}
              type={projectTypeLabel}
              category={currentProject?.researchCategory}
              subCategory={currentProject?.researchSubCategory}
            />
          }
          resizeHeader={true}
          removePadding={true}
          marginBottom={true}
        >
          <CreateActivity
            currentProject={currentProject?.id}
            files={stateFiles}
            getFiles={getAttachments}
            projectType={projectTypeLabel}
            format={formatName}
            type={type}
            listAttachments={() => setShowAttachmentModal("research")}
            onSuccess={onActivityCreated}
          />
        </ScriptBox>
      )}
    </>
  );
};

export default NewActivityModals;
